import { render, staticRenderFns } from "./Select-doencas.vue?vue&type=template&id=454afb08&"
import script from "./Select-doencas.vue?vue&type=script&lang=js&"
export * from "./Select-doencas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports